// dependencies
import React from 'react'
import papa from 'papaparse'

// import toast from '_root/lib/toast.js'
import PropTypes from 'prop-types'

// components
import { Button } from '@st-operations/uikit/src/v2/index.js'

// lib
import downloadCSV from '_lib/downloadCSV.js'
import toast from '@st-operations/uikit/lib/toast'
import { usePDPEnvironment } from '../../../../contexts/PDPEnvContext'

// styles
import './styles.scss'

const download = (partnerName, data, close, env) => {
  try {
    if (data) {
      const fields = ['publicAccessKey', 'secretAccessKey']
      const csv = papa.unparse({ fields, data: [data] })
      downloadCSV(csv, `source_partner_${partnerName}-${env}_s3_access_key`)
      close()
      toast.success('Key downloaded successfully')
    }
  } catch (error) {
    toast.error('Error while downloading API key')
  }
}

// component
const NewS3AccessKeyModal = ({ partnerName, data, close }) => {
  const { pdpEnvironment } = usePDPEnvironment()
  return (
    <section className="new-s3-key-modal">
      <div className="new-s3-key-modal__download-modal">
        {' '}
        <h1 style={{ fontSize: '20px', fontWeight: '600' }}>
          This s3 secret access key is only available to download at this time. You will not be able
          to retrieve it later. If lost, create a new key.
        </h1>
        <Button
          onClick={() => {
            download(partnerName, data, close, pdpEnvironment.value)
          }}
        >
          Download S3 Key
        </Button>{' '}
      </div>
    </section>
  )
}

NewS3AccessKeyModal.propTypes = {
  open: PropTypes.bool,
  partnerName: PropTypes.string,
  createdBy: PropTypes.string,
  close: PropTypes.func,
}

NewS3AccessKeyModal.defaultProperties = {
  open: false,
  partnerName: '',
  createdBy: '',
  close: () => {},
}

// export
export default NewS3AccessKeyModal
